export const BlipNamespace = Object.freeze({
  NOTICE: 10,
  NOTIFICATION: 20,
  PROFILE: 30,
  COLLECTION: 100,
  COLLECTION_COMMENT: 101,
  TOPIC: 200,
  TOPIC_COMMENT: 201,
  RADAR: 300,
  RADAR_COMMENT: 301,
  SCHEDULE: 400,
  VIEWER: 500,
  VIEWER_COMMENT: 501,
  KPOP_NOW_COMMENT: 511,
  TODAY: 600,
  FAN_LOG: 700,
  THREAD: 1000,
  THREAD_COMMENT: 1001,
  TIMELINE: 1500,
  ARTIST: 2000,
  USER_REPORT: 3000,
});

export const BlipNamespaceOptions = Object.freeze([
  {
    value: BlipNamespace.RADAR,
    label: "트렌드",
  },
  {
    value: BlipNamespace.VIEWER_COMMENT,
    label: "뷰어 댓글",
  },
  {
    value: BlipNamespace.KPOP_NOW_COMMENT,
    label: "KPOP NOW 댓글",
  },

  {
    value: BlipNamespace.COLLECTION,
    label: "갤러리",
  },
  {
    value: BlipNamespace.COLLECTION_COMMENT,
    label: "갤러리 댓글",
  },
  {
    value: BlipNamespace.TOPIC,
    label: "토픽",
  },
  {
    value: BlipNamespace.TOPIC_COMMENT,
    label: "토픽 댓글",
  },

  {
    value: BlipNamespace.FAN_LOG,
    label: "팬로그",
  },

  {
    value: BlipNamespace.THREAD_COMMENT,
    label: "불판",
  },

  {
    value: BlipNamespace.USER_REPORT,
    label: "유저신고",
  },
]);
